import { Injectable } from '@angular/core';
import { HttpEvent, HttpRequest, HttpResponse, HttpInterceptor, HttpHandler } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RequestCacheService } from 'src/app/services/request-cache.service';

export const TTL = 3600; // in seconds

@Injectable({
  providedIn: 'root',
})
export class CacheInterceptor implements HttpInterceptor {
  constructor(private cache: RequestCacheService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (environment.disableCache || this.shouldBypass(req)) {
      return this.sendRequest(req, next);
    }

    const cachedResponse = this.cache.get(req.urlWithParams);

    return cachedResponse ? of(cachedResponse) : this.sendRequest(req, next);
  }

  private sendRequest(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse && !this.shouldBypass(req)) {
          this.cache.set(req.urlWithParams, event, TTL);
        }
      })
    );
  }

  private shouldBypass(req: HttpRequest<any>): boolean {
    let bypass = false;

    if (req.method !== 'GET') {
      // won't cache non idempotent calls
      bypass = true;
    }

    if (req.url.endsWith('/ratings')) {
      bypass = true;
    }

    if (req.url.endsWith('/checkouts/history')) {
      bypass = true;
    }

    if (req.url.includes('/notifications')) {
      bypass = true;
    }

    if (req.url.includes('/comments')) {
      bypass = true;
    }

    return bypass;
  }
}
